module.exports = __webpack_public_path__ + "static/media/button_appstore_apple.ca98896c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/button_appstore_apple.svg
// module id = 71
// module chunks = 0